import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MaterialUiListItem from '@material-ui/core/ListItem';
import List from 'Common/List';
import MaterialUiListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { createStyles, Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        paddingLeft: theme.spacing(1.5)
    },
    padding: {
        paddingLeft: theme.spacing(1.5),
    }
});

/**
 * The properties this component can receive.
 */
interface IProps {
    button?: boolean;
    label?: string;
    children: any;
    classes: any;
}

/**
 * The index signature key value pairs this state can store.
 */
interface IState {
    open: boolean;
}

/**
 * The class for creating a React component that renders a MaterialUi List Item
 * that can expand, revealing child components.
 */
class ExpandableListItem extends React.Component<IProps, IState> {

    public static muiName = 'ExpandableListItem';

    /**
     * Creates a new instance of the ExpandableListItem component.
     * @param props - The passed in properties.
     */
    constructor(props: IProps) {
        super(props);

        this.state = {
            open: false
        }
    }

    /**
     * Toggle the expanded list item.
     */
    toggleExpandedList = () => {
        this.setState((previousState: IState) => ({ open: !previousState.open }));
    }

    render() {
        const { children, classes } = this.props;
        const { open } = this.state;

        const ListItem = this.props.button ?
            (wrapper: any) => <MaterialUiListItem button onClick={this.toggleExpandedList}>{wrapper.children}</MaterialUiListItem> :
            (wrapper: any) => <MaterialUiListItem onClick={this.toggleExpandedList}>{wrapper.children}</MaterialUiListItem>


        return (
            <div>
                <ListItem>
                    {
                        this.props.label &&
                        <MaterialUiListItemText primary={this.props.label} />
                    }
                    {
                        open ? <ExpandLess /> : <ExpandMore />
                    }
                </ListItem>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List disablePadding={true} className={classes.padding}>
                        {...children}
                    </List>
                </Collapse>
            </div>
        );
    }
}

export default withStyles(styles)(ExpandableListItem);